import React, { useEffect, useState } from "react";

import useUserRoles from "../AdminHooks/useUSerRoles";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import LoadingSpinner from "../Utilities/LoadSpinner";

import axios from "axios";
import { useAuth } from "../Contexts/AuthContext";

const SuperAdminDashboard: React.FC = () => {
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isSuperAdmin = useUserRoles().isSuperAdmin;
  const [latestBookings, setLatestBookings] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLatestBookings = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        console.log("Access Token:", accessToken);

        const response = await axios.get<{ data: any[] }>(
          `${process.env.REACT_APP_API_URL}/Booking/latestBookings`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );

        console.log("Latest bookings response:", response);
        setLatestBookings(response.data.data); // Access the data property
        setLoading(false);
      } catch (error) {
        console.error("Error fetching latest bookings:", error);
        setLoading(false);
      }
    };

    fetchLatestBookings();
  }, []);

  if (!isAuthenticated) {
    navigate("/login");
  }

  return (
    <>
      <section className="manager-dashboard">
      
        <div className="dashboard-sections">
          <Link to="/campsites" className="dashboard-section">
            Campsite Manager
          </Link>
          <Link to="/businessUserManager" className="dashboard-section">
            Manage Tour Operators
          </Link>
          <Link to="/privateUserManager" className="dashboard-section">
            Manage Private Users
          </Link>
          <Link to="/bookingManager" className="dashboard-section">
            Booking Manager
          </Link>
          <Link to="/adminManager" className="dashboard-section">
            Admin Manager
          </Link>
        </div>
        <div className="latest-bookings">
          <h2>Latest Bookings</h2>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="booking-dashboard-list">
              <div className="list-header">
                <span>Order Number</span>
                <span>Created At</span>
                <span>Customer</span>
                <span>Campsite</span>
                <span>Arrival Date</span>
                <span>Departure Date</span>
              </div>
              <ul className="list-group">
                {latestBookings.map((booking) => (
                  <li key={booking.orderNumber} className="list-group-item">
                    <div className="booking-field orderNumber">
                      {booking.orderNumber}
                    </div>
                    <div className="booking-field createdAt">
                      {format(
                        new Date(Date.parse(booking.createdAt)),
                        "yyyy-MM-dd"
                      )}
                    </div>
                    <div className="booking-field customer">
                      {booking.customerName}
                    </div>
                    {booking.bookings.map((subBooking: any) => (
                      <React.Fragment key={subBooking.bookingId}>
                        <div className="booking-field campsite">
                          {subBooking.campSiteName}
                        </div>
                        <div className="booking-field arrivalDate">
                          {format(
                            new Date(Date.parse(subBooking.arrivalDate)),
                            "yyyy-MM-dd"
                          )}
                        </div>
                        <div className="booking-field departureDate">
                          {format(
                            new Date(Date.parse(subBooking.departureDate)),
                            "yyyy-MM-dd"
                          )}
                        </div>
                      </React.Fragment>
                    ))}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SuperAdminDashboard;
